import Channels from '../../../weon/models/Channels';

const state = {
  channels: new Channels(),
  chatVisor: false,
  latestVoiceStatusBeforeDisconnect: {
    status: '',
    description: '',
  },
};

export default state;
